import React, { useState } from "react";
import {
  Button,
  Box,
  Typography,
  Modal,
  useTheme,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { toast } from "react-toastify";
import AccessibleIconButton from "components/base/AccessibleIconButton";

const DeleteWorkCitedPopup = ({
  deletePopup,
  setDeletePopup,
  deleteBookmarkSource,
}) => {
  const [loading, setLoading] = useState(false);
  const theme = useTheme();
  const navbarBackground = theme.palette?.navbar?.main;

  const handleDelete = async () => {
    setLoading(true);
    try {
      await deleteBookmarkSource();
    } catch (error) {
      toast.error("Failed to delete works cited");
    } finally {
      setLoading(false);
    }
  };

  const onClose = () => {
    setDeletePopup(false);
  };

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { xs: "100vw", sm: "50vw", md: "35vw" },
    bgcolor: "background.paper",
    boxShadow: 0,
    borderRadius: 2,
  };

  return (
    <Modal
      open={deletePopup}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <Box sx={modalStyle}>
        <Box sx={{ p: 4 }}>
          <Typography
            variant="h4"
            component="div"
            color="#406da4"
            fontWeight="600"
          >
            Confirm Deletion
          </Typography>
          <AccessibleIconButton
            title="Close"
            onClick={onClose}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </AccessibleIconButton>
          <Typography sx={{ mt: 2 }}>
            Are you sure you want to delete this Works Cited?
          </Typography>
        </Box>

        <Box
          sx={{
            backgroundColor: navbarBackground,
            display: "flex",
            justifyContent: "space-between",
            gap: 5,
            px: 5,
            py: 3,
            borderRadius: "0 0 20px 20px",
          }}
        >
          <Button
            onClick={onClose}
            variant="outlined"
            disabled={loading}
            sx={{ width: "45%", textTransform: "none", borderColor: "#406da4" }}
          >
            <Typography variant="h6" sx={{ color: "#406da4" }}>
              Cancel
            </Typography>
          </Button>
          <Button
            onClick={handleDelete}
            disabled={loading}
            sx={{
              width: "45%",
              textTransform: "none",
              backgroundColor: "#406da4",
              display: "flex",
              gap: 1,
            }}
          >
            {loading && <CircularProgress size={20} />}
            <Typography variant="h6">Delete</Typography>
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default DeleteWorkCitedPopup;
